import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionManagerService } from '../../shared/storage/session-manager.service';
import { LOGGER } from '../logging/log.service';
import { PERMISSION_RESOURCE } from '../permissions/permissions.types';

export const lvrPermissionGuard = (permission: PERMISSION_RESOURCE | PERMISSION_RESOURCE[]): CanActivateFn => {
	return async () => {
		const session = inject(SessionManagerService);
		const router = inject(Router);
		const logger = inject(LOGGER);

		const requiredPermissions = Array.isArray(permission) ? permission : [permission];
		await session.waitForPermissionsLoaded();

		const permissions = session.permissions();
		const found = permissions.some((perm) =>
			requiredPermissions.some((p) => p.toLowerCase() === perm.name.toLowerCase()),
		);
		logger.log(
			'🔑 Checked permissions for user (user permissions, required permission, found): ',
			false,
			permissions,
			permission,
			found,
		);
		if (found) return true;
		logger.log('⛔ User lacks required permission, redirecting to error page.', false, permission);
		return router.createUrlTree(['error']);
	};
};
